// extracted by mini-css-extract-plugin
module.exports = {"container":"SimpleFooter_container__0QpDy"};